'use client';

import { ErrorState } from '@/components/ui';
import { useBoundaryErrorReport } from '@/hooks/useBoundaryErrorReport';

export default function LocaleError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useBoundaryErrorReport(error, 'locale-segment');

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md items-center justify-center px-6">
      <ErrorState onRetry={reset} />
    </div>
  );
}
